import { render, staticRenderFns } from "./RecordtableResources.vue?vue&type=template&id=5d5f9ee6&"
import script from "./RecordtableResources.vue?vue&type=script&lang=js&"
export * from "./RecordtableResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports